import { IChartingLibraryWidget } from '@frontends/feature-charting-library/charting_library';
import { parseCurrentQuery } from '@frontends/util-utils';
import { TEntityConfig } from '../../../hooks/useEntityConfig';
import i18n from '../../../i18n';

export const widgetReadyTradingView = (
  widgetInstance: IChartingLibraryWidget,
  config: TEntityConfig,
): (() => void) | undefined => {
  if (!config.VITE_URL_TRADING_VIEW) {
    return;
  }

  const button = widgetInstance.createButton({
    align: 'left',
  });
  const handleLinkReplay = (): void => {
    window.location.href = parseCurrentQuery(config.VITE_URL_TRADING_VIEW);
  };
  const icon = `<svg role="img" height="19" width="19" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Tradingview--Streamline-Simple-Icons">
  <path d="M15.8654 8.2789c0 1.3541 -1.0978 2.4519 -2.452 2.4519 -1.354 0 -2.4519 -1.0978 -2.4519 -2.452 0 -1.354 1.0978 -2.4518 2.452 -2.4518 1.3541 0 2.4519 1.0977 2.4519 2.4519zM9.75 6H0v4.9038h4.8462v7.2692H9.75Zm8.5962 0H24l-5.1058 12.173h-5.6538z" fill="currentColor" stroke-width="1"></path>
</svg>`;

  button.setAttribute('title', i18n.t('buttonTradingView'));
  button.style.paddingLeft = '5px';
  button.style.paddingRight = '5px';
  button.classList.add('apply-common-tooltip');
  button.style.cursor = 'pointer';
  button.style.display = 'flex';
  button.style.alignItems = 'center';
  button.style.justifyContent = 'center';
  button.style.gap = '5px';
  button.style.color = 'var(--textPrimary)';
  button.addEventListener('click', handleLinkReplay);
  button.innerHTML = `${icon} ${i18n.t('tradingView')}`;

  return () => {
    button.removeEventListener('click', handleLinkReplay);
  };
};

// Maybe in the future
// export const widgetReadySelectAccount = (widgetInstance: any, contextAccount: IAccount) => {
//     widgetInstance.createDropdown({
//         title: t("buttonAccount", { acc_id: contextAccount.selectedClientAccountId }),
//         items: contextAccount.clientAccounts.map((account) => ({
//             title: `${account.id} ${account.description ? `- ${account.description}` : ""}`,
//             value: account.id,
//             onSelect: () => {
//                 contextAccount.selectAccount(account.id)
//             }
//         })),
//     })
// }
